import React from "react"
import { connect } from "react-redux"
import USD from "../usd"
import { calculateCart } from "../../shop/common"

const CartSummary = props => {
  const { amountWithoutTax, totalAmount } = calculateCart(props.cart, props.products)
  const currencyName = props.currency == 'usd' ? '' : ` (${props.currency.toUpperCase()})`

  return (
    <div className="shop-cart-summary panel panel-success">
      <div className="panel-heading">{`Current Sale${currencyName}`}</div>
      <div className="panel-body">
        <USD className="shop-cart-summary__value" val={props.withoutTax ? amountWithoutTax : totalAmount}/>
        <div className="shop-cart-summary__question" onClick={props.onClickQuestion}>?</div>
      </div>
    </div>
  )
}

const mapStateToProps = state =>
  ({cart: state.currentShop.cart, products: state.entities.products});

export default connect(mapStateToProps)(CartSummary)
